module.exports = __webpack_public_path__ + "img/success.aa9afad0.png";